var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkMeditation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 459,
    height: 366,
    viewBox: "0 0 459 366",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_581_2044)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.5387 193.392C111.139 162.522 123.849 101.762 132.819 53.8716C136.739 32.9416 146.809 17.8516 168.119 17.8516C192.749 17.8516 204.599 37.8116 204.599 62.4316V160.462C220.219 164.772 229.129 175.812 229.129 197.152C229.129 214.532 225.909 241.722 222.029 268.222C215.249 314.462 174.829 347.582 128.099 347.582H17.8488C17.8488 347.582 9.71875 305.062 9.71875 277.512C9.71875 249.962 17.8488 207.452 17.8488 207.452H54.6187C67.6087 207.452 80.8688 203.872 88.5387 193.402V193.392Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8516 207.449H54.6216C67.6116 207.449 80.8716 203.869 88.5416 193.399C111.142 162.529 123.852 101.769 132.822 53.8794C136.742 32.9494 146.812 17.8594 168.122 17.8594C192.752 17.8594 204.602 37.8194 204.602 62.4394V160.599",
    stroke: "#e5eaf9",
    strokeWidth: 35.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.952 239.303L168.512 182.283C172.432 166.363 188.482 156.603 204.382 160.483C219.252 164.103 229.132 175.293 229.132 197.153C229.132 214.533 225.912 241.723 222.032 268.223C215.252 314.463 174.832 347.583 128.102 347.583H17.8516",
    stroke: "#e5eaf9",
    strokeWidth: 35.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.668 193.392C347.068 162.522 334.358 101.762 325.388 53.8716C321.468 32.9416 311.398 17.8516 290.088 17.8516C265.458 17.8516 253.608 37.8116 253.608 62.4316V160.462C237.988 164.772 229.078 175.812 229.078 197.152C229.078 214.532 232.298 241.722 236.178 268.222C242.958 314.462 283.378 347.582 330.108 347.582H440.348C440.348 347.582 448.478 305.062 448.478 277.512C448.478 249.962 440.348 207.452 440.348 207.452H403.578C390.588 207.452 377.328 203.872 369.658 193.402L369.668 193.392Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.359 207.449H403.589C390.599 207.449 377.339 203.869 369.669 193.399C347.069 162.529 334.359 101.769 325.389 53.8794C321.469 32.9494 311.399 17.8594 290.089 17.8594C265.459 17.8594 253.609 37.8194 253.609 62.4394V160.599",
    stroke: "#e5eaf9",
    strokeWidth: 35.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.258 239.303L289.698 182.283C285.778 166.363 269.728 156.603 253.828 160.483C238.958 164.103 229.078 175.293 229.078 197.153C229.078 214.533 232.298 241.723 236.178 268.223C242.958 314.463 283.378 347.583 330.108 347.583H440.348",
    stroke: "#e5eaf9",
    strokeWidth: 35.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_581_2044"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 458.21,
    height: 365.44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkMeditation);
export default __webpack_public_path__ + "static/media/dark-meditation.e9a257d59bc03fb947acd7e3f60c94ea.svg";
export { ForwardRef as ReactComponent };